/**
 * Direct Buy Banner
 */

import { isNfbCustomer } from 'scripts/helpers/_utils';
import { readCookie, createCookieIfMissing } from 'scripts/modules/_cookies';

export const initBannerPromo = () => {
	const banner = document.querySelector( '.banner-promo' );
	const closeButton = document.querySelector( '#closeTopPromoBanner' );

	const removeBanner = () => {
		if ( banner ) {
			banner.classList.add( 'd-none' );
			banner.classList.remove( 'd-block' );
			document.querySelector( 'header' )?.classList?.add( 'without-promo-banner' );
		}
	};

	if ( !! isNfbCustomer() || readCookie( 'closed_promo_top_bar' ) ) {
		removeBanner();
	}

	if ( closeButton ) {
		closeButton.addEventListener( 'click', ( event ) => {
			event.stopPropagation();
			event.preventDefault();

			let daysLeft = parseInt( banner.getAttribute( 'data-days-left' ) );
			if ( daysLeft < 0 ) {
				daysLeft = 1;
			}

			createCookieIfMissing( 'closed_promo_top_bar', 'true', daysLeft );

			removeBanner();

			return false;
		} );
	}
};
